import { render } from "./extra_buttons.vue?vue&type=template&id=ef1a1d8e"
import script from "./extra_buttons.js?vue&type=script&lang=js"
export * from "./extra_buttons.js?vue&type=script&lang=js"

import "./extra_buttons.vue?vue&type=style&index=0&id=ef1a1d8e&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__